import { createApp } from 'vue';
import App from './App.vue';
import VueAxios from 'vue-axios'
// import './registerServiceWorker'
import { TUIComponents, TUICore, genTestUserSig } from './TUIKit';
import 'element-plus/dist/index.css'
import VueCookies from 'vue-cookies'
const SDKAppID = 1400757726; // Your SDKAppID
import axios from 'axios'
import mitt from 'mitt'

import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const Mit = mitt()
declare module "vue" {
  export interface ComponentCustomProperties {
    $Bus: typeof Mit
  }
}
// axios.defaults.baseURL = '/api'
// axios.defaults.baseURL = process.env.VUE_APP_MODE === 'development' ? '/api' : '';
axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/api' : '';
// init TUIKit
const TUIKit = TUICore.init({
  SDKAppID,
});
// TUIKit add TUIComponents
TUIKit.use(TUIComponents);


const app = createApp(App)

app.config.globalProperties.$rqst = axios

app.config.globalProperties.$cookies = VueCookies
app.config.globalProperties.$Bus = Mit
app.use(TUIKit)
app.use(VueAxios, axios)
app.use(ElementPlus)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mount('#app');